import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";

export type BackendDebtClient = {
	clientId: string;
	fullName: string;
	phone: string;
	buildingName: string;
	roomNumber: string;
	totalDebt: number;
	overdueAmount: number;
	overdueCount: number;
	maxDelayDays: number;
	lastPaymentDate: string | null;
	managerName: string;
};

export type BackendDebtReport = {
	totalDebtors: number;
	totalDebt: number;
	totalOverdue: number;
	clients: BackendDebtClient[];
};

export type DebtReportData = {
	totalDebtors: number;
	totalDebt: number;
	totalOverdue: number;
	clients: BackendDebtClient[];
};

export type DebtReportParams = {
	buildingId?: string;
	managerId?: string;
	minDaysOverdue?: number;
};

export async function getDebtReport(params?: DebtReportParams): Promise<DebtReportData> {
	const response = await apiClient.get<{ success: boolean; data: BackendDebtReport }>(
		endpoints.reports.debts,
		{ params }
	);
	return response.data.data;
}
